import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "The aluminium ribbon is supplied with a voltage that causes a current I to flow through it. As the ribbon is in the magnetic field B, a Lorentz force is created which causes the ribbon to vibrate with a speed V. The ribbon is then subjected to an induced EMF which attempts to oppose the current I.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/04/09/principle/video.mp4`,
            },
          },
          styles: {
            padding: "1% 5.65%",
          },
        },
      },
    },
  },
};

export default principle;
